export default "/images/pa_teacher_practices_sm.jpg?65a361eb1aaae42c3ffeaecb3053c162";